"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTexts = exports.useLocaleString = exports.useLocale = exports.useI18n = exports.i18nContext = void 0;
var react_1 = __importDefault(require("react"));
var raw = require('core-js-pure/stable/string/raw');
exports.i18nContext = react_1.default.createContext({
    // Faking default locale as EN
    locale: 'en',
    translations: {},
});
var useI18n = function () {
    return react_1.default.useContext(exports.i18nContext);
};
exports.useI18n = useI18n;
var useLocale = function () {
    var locale = (0, exports.useI18n)().locale;
    return locale;
};
exports.useLocale = useLocale;
var useLocaleString = function () {
    console.warn('useLocaleString() was deprecated. Use useLocale() instead.');
    return (0, exports.useLocale)();
};
exports.useLocaleString = useLocaleString;
var useTexts = function (locale) {
    var _a = (0, exports.useI18n)(), translations = _a.translations, contextLocaleString = _a.locale;
    var resource = translations[locale || contextLocaleString];
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var key = raw.apply(void 0, args);
        if (!resource)
            return key;
        if (typeof resource[key] !== 'string')
            return key;
        return resource[key];
    };
};
exports.useTexts = useTexts;
